import React, { useEffect, useState, useMemo } from 'react'
import withRouter from '../../hocs/withRouter'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { useNavigate } from 'react-router-dom'

import { formatError } from '../../../utils'
import {
  makeGetArtistById,
} from '../../../selectors'
import { 
  show,
  incrementViewCount, 
  addBandsToArtist, 
} from '../../../actions'
import useMediaQuery from '@mui/material/useMediaQuery'
import DetailPageWithVideoContext from '../../pages/DetailPageWithVideoContext'


import {
  SEO, 
  Broadcast, 
  MerchantAccountTab
} from '../../generics'



import ArtistInfo from './ArtistInfo'
import ArtistTracks from './ArtistTracks'
import ArtistDetailMainButton from './ArtistDetailMainButton'
import ArtistPerformances from './ArtistPerformances'
import ArtistImages from './ArtistImages'
import ArtistProducts from './ArtistProducts'
import AlbumIcon from '@mui/icons-material/Album'
import TicketIcon from '@mui/icons-material/ConfirmationNumberSharp'
import ImageIcon from '@mui/icons-material/Image'
import SellIcon from '@mui/icons-material/Sell'




const ArtistDetailPage = props => {

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))
  const navigate = useNavigate()

  const {
    id,
    isArtist,
    isLoaded,
    isMerchant,
    stripeId,
    show,
    name,
    bio,
    imageURL,
    videoURL,
    originalImage,
    externalImageURL,
    incrementViewCount
  } = props


  const jsonLdData = {
    "@context": "http://schema.org",
    "@type": "Person",
    "url": "https://www.ckord.com/artists/" + id,
    "name": name,
    "description": bio,
    "image": [imageURL]
  }


  const [links, setLinks] = useState({})



  useEffect(() => {
    show('/artists/' + id, 'ARTIST').catch(error => {
      error = formatError(error)

      if (error.status === 404) {
        navigate('/page-not-found', { replace: true, state: { page: 'artist' }})
      }
    })
  }, [id, show, navigate])





  useEffect(() => {
    if (isLoaded) {
      incrementViewCount('/artists/' + id + '/views', 'ARTIST', id)
    }
  }, [isLoaded, incrementViewCount, id])




  const ProductsTab = useMemo(() => {
    if (!isMerchant && isArtist) {
      return <MerchantAccountTab id={ id } type='artist' name={ name } stripeId={stripeId} />
    } else if (isMerchant) {
      return (
        <ArtistProducts artistId={ id } type='product' links={ links } setLinks={ setLinks } />
      )
    } else {
      return null
    }
  }, [isMerchant, isArtist, id, links, name, stripeId])




  return (isLoaded &&
    <div style={{ height: '100%' }}>
      <SEO 
        url={process.env.REACT_APP_API_URL + id}
        image={imageURL}
        title={name + ' | Ckord'}
        description={`Check out ${name} on Ckord`}
        jsonLdData={jsonLdData}
      />


      <DetailPageWithVideoContext
        image={ imageURL || externalImageURL }
        originalImage={ originalImage }
        video={videoURL}
        MainButton={<ArtistDetailMainButton artistId={id} isOwner={isArtist} />}
        Broadcast={<Broadcast id={id} type='artist' isOwner={isArtist} />}
        information={<ArtistInfo artistId={id} links={links} setLinks={setLinks} />}

        tab1={ <ArtistPerformances artistId={ id } /> }
        tab1Label={ isExtraSmallScreen ? <TicketIcon /> : 'events' }

        tab2={ <ArtistTracks artistId={ id } /> }
        tab2Label={ isExtraSmallScreen ? <AlbumIcon /> : 'music' }
        
        tab3={ <ArtistImages artistId={ id } /> }
        tab3Label={ isExtraSmallScreen ? <ImageIcon /> : 'images' }
        
        tab4={ProductsTab}
        tab4Label={
          !Boolean(ProductsTab) ? false : 
          isExtraSmallScreen ? <SellIcon /> : 'merch'
        }
      />
    </div>
  )
}



const makeMapStateToProps = () => {
  const getArtistById = makeGetArtistById()

  const mapStateToProps = (state, props) => {
    const id = props.id

    const artist = getArtistById(state, id)

    const attributes = artist?.attributes || {}

    const role = state?.user?.attributes?.role

    const imageURL = attributes.imageDerivatives?.large || attributes.image

    const externalImageURL = attributes.externalImageUrl

    const videoURL = attributes.video


    return {
      isArtist: ['admin', 'editor'].includes(role) || (state.user.account.id === id),
      isLoaded: Boolean(artist.id),
      isMerchant: get(artist, ['attributes', 'isMerchant'], ''),
      imageURL: imageURL,
      videoURL: videoURL,
      originalImage: attributes.image,
      externalImageURL: externalImageURL,
      name: attributes.name || '',
      bio: attributes.bio || '',
      stripeId: attributes.stripeId
    }
  }

  return mapStateToProps
}


const actions = { show, incrementViewCount, addBandsToArtist  }


export default withRouter(connect(makeMapStateToProps, actions)(ArtistDetailPage))


